import React from "react";
import { useTheme } from "../contexts/ThemeContext.jsx";
import { useAuth } from "../hooks/useAuth.js";

const ProjectLayout = ({ children, project, navigationItems }) => {
  const { currentTheme, toggleTheme } = useTheme();
  const { user } = useAuth();

  return (
    <div className="grid-container">
      <header className="header">
        <div className="header-top">
          <div className="header-content">
            <div className="logo-section">
              <div className="logo">
                <a href="/">
                  <img
                    src={
                      currentTheme === "light"
                        ? "/MF_Logo_RGB_Black.png"
                        : "/MF_Logo_RGB_White.png"
                    }
                    alt="Malheur & Fortuna"
                  />
                </a>
              </div>
              <div className="user-avatar-dropdown">
                <div className="user-avatar">
                  {user?.name?.substring(0, 2) || "U"}
                </div>
              </div>
            </div>

            <div className="status-info">
              <span className="status-text">Verbunden</span>
              <div className="status-indicator connected"></div>
            </div>
          </div>
        </div>

        <div className="page-title-section">
          <h1>
            {project.code} - {project.title}
          </h1>

          <nav className="navigation">
            {navigationItems.map((item) => (
              <button
                key={item.id}
                onClick={item.onClick}
                className={`nav-item ${item.active ? "active" : ""}`}
              >
                {item.label}
              </button>
            ))}

            <div className="theme-slider">
              <div
                className={`slider-option ${
                  currentTheme === "light" ? "active" : ""
                }`}
                onClick={() => currentTheme !== "light" && toggleTheme()}
              >
                L
              </div>
              <div
                className={`slider-option ${
                  currentTheme === "dark" ? "active" : ""
                }`}
                onClick={() => currentTheme !== "dark" && toggleTheme()}
              >
                D
              </div>
            </div>
          </nav>
        </div>
      </header>

      <main className="main-content">
        <div className="content-area">{children}</div>
      </main>
    </div>
  );
};

export default ProjectLayout;
